import React, { useContext, useEffect, useState } from "react";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import DataTable from "react-data-table-component";
import FilterComponent from "../../FilterComponents/FilterComponent";
import { useThemeContext } from "../../../Context/ThemeContext";
import { filterSearch } from "../../../Utils/FilterItems";
import ModalTambahStaf from "../components/ModalTambahStaf";
import StafColumns from "../constants/TableColumns";
import { CreateButton } from "../../../CommonElements";
import FilterDropdown from "../../FilterComponents/FilterDropdown";
import { PERMISSIONS } from "../../../Constant/FeatureSelection";
import RoleContext from "../../../Context/RoleContext";
import { useStaf } from "../../../Context/StafContext";

const StaffContainer = () => {
  const stafAPI = useStaf();
  const { themeContext } = useThemeContext();
  const { checkPermission } = useContext(RoleContext);
  const [pending, setPending] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [options, setOptions] = useState({
    Status: [],
    Grup: [],
  });
  const [selectedItems, setSelectedItems] = useState({
    Status: [],
    Grup: [],
  });
  const toggle = () => setModalOpen(!modalOpen);

  useEffect(() => {
    refreshStaff();
    refreshStatusStaf();
    refreshGroupStaf();
  }, []);

  const refreshStaff = () => {
    stafAPI.getStaf().then((res) => {
      setStaffList(res.data);
      setPending(false);
    });
  };

  const refreshStatusStaf = () => {
    stafAPI.getStatusStaf().then((res) => {
      const mappedStatus = res.data.map((item) => ({
        id: item.id_status_staf,
        name: item.nama_status_staf,
      }));

      setOptions((prev) => ({
        ...prev,
        Status: mappedStatus,
      }));
    });
  };

  const refreshGroupStaf = () => {
    stafAPI.getGroupStaf().then((res) => {
      const mappedStatus = res.data.map((item) => ({
        id: item.id_group,
        name: item.nama,
      }));

      setOptions((prev) => ({
        ...prev,
        Grup: mappedStatus,
      }));
    });
  };

  const filterStatus = (selectedStatuses) => (item) =>
    selectedStatuses.length === 0 ||
    selectedStatuses.includes(item.status_staf);

  const filterGroup = (selectedGroups) => (item) =>
    selectedGroups.length === 0 || selectedGroups.includes(item.group_staf);

  const filterStaff = (items) => {
    const searchCategories = [
      "nama",
      "nip",
      "nup_ui",
      "group_nama",
      "username_ldap",
      "ruangan",
      "ext_telp",
      "telp",
    ];
    const filteredItems = items
      .filter(filterSearch(searchCategories, filterText))
      .filter(filterStatus(selectedItems.Status))
      .filter(filterGroup(selectedItems.Grup));
    return filteredItems;
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <FeatureContainer
      title={"Staff"}
      createButton={
        checkPermission(PERMISSIONS.ADD_STAF) && (
          <CreateButton toggle={toggle}>Tambah Staf</CreateButton>
        )
      }
    >
      <DataTable
        columns={StafColumns(refreshStaff, staffList)}
        data={filterStaff(staffList)}
        pagination
        selectableRowsHighlight
        highlightOnHover
        subHeader
        subHeaderComponent={
          <div className="d-flex flex-row gap-3 mb-3">
            <FilterDropdown
              options={options}
              setState={setSelectedItems}
              state={selectedItems}
            />
            <FilterComponent
              onFilter={(e) => {
                setFilterText(e.target.value);
              }}
              onClear={() => handleClear()}
              filterText={filterText}
            />
          </div>
        }
        subHeaderAlign="right"
        persistTableHead
        progressPending={pending}
        theme={themeContext}
      />
      <ModalTambahStaf create toggle={toggle} isOpen={modalOpen} />
    </FeatureContainer>
  );
};

export default StaffContainer;
